import React, { useState, useEffect } from "react";

export default function PERCENTAGEtest(props) {
  const correctAnswers = [1, 0, 1, 2, 2, 0, 1, 0, 1, 1, 0, 1, 0, 2, 0, 1, 2, 2, 0, 0, 0, 2, 0, 0, 0];
  const que = {
    q1: {
      string: "1. If 20% of a number is 60, what is the number?",
      options: ["200", "240", "250", "300"],
      ans: 1
    },
    q2: {
      string: "2. If 25% of a number is subtracted from 80, the result is 60. What is the number?",
      options: ["120", "160", "180", "200"],
      ans: 0
    },
    q3: {
      string: "3. If the price of a product is increased by 20% and then decreased by 10%, what is the net percentage change?",
      options: ["10% increase", "5% increase", "5% decrease", "10% decrease"],
      ans: 1
    },
    q4: {
      string: "4. If the price of a product is decreased by 25%, by what percentage should it be increased to get back to its original price?",
      options: ["25%", "30%", "33.33%", "40%"],
      ans: 2
    },
    q5: {
      string: "5. If the population of a town increased by 10% each year for 3 years, what is the total percentage increase in the population?",
      options: ["10%", "20%", "30%", "33.1%"],
      ans: 2
    },
    q6: {
      string: "6. If a number is increased by 20% and then decreased by 20%, what is the net percentage change?",
      options: ["0%", "4%", "16%", "20%"],
      ans: 0
    },
    q7: {
      string: "7. A car's value depreciates by 10% each year. What is its value after 3 years if its initial value is $10,000?",
      options: ["$7000", "$7290", "$7295", "$7299"],
      ans: 1
    },
    q8: {
      string: "8. If the price of a product is increased by 10% and then decreased by 10%, what is the net percentage change?",
      options: ["0%", "1%", "10%", "11%"],
      ans: 0
    },
    q9: {
      string: "9. If a student scores 60% marks and fails by 10 marks, what is the maximum marks for the exam?",
      options: ["100", "200", "300", "400"],
      ans: 1
    },
    q10: {
      string: "10. Which of the following is not a valid data type in C++?",
      options: ["int", "string", "char", "bool"],
      ans: 1
    },
    q11: {
      string: "11. What is the correct syntax for a function pointer in C++?",
      options: ["void (*ptr)();", "void *ptr();", "void ptr();", "void (*ptr);"],
      ans: 0
    },
    q12: {
      string: "12. If a salary is increased by 20% and then decreased by 20%, what is the net percentage change in the salary?",
      options: ["0%", "4%", "16%", "20%"],
      ans: 0
    },
    q13: {
      string: "13. If a number is increased by 30% and then decreased by 20%, what is the net percentage change?",
      options: ["4% increase", "4% decrease", "6% increase", "6% decrease"],
      ans: 1
    },
    q14: {
      string: "14. A price is increased by 10% and then decreased by 10%. What is the percentage change in the price?",
      options: ["0%", "1%", "10%", "20%"],
      ans: 0
    },
    q15: {
      string: "15. If the length of a rectangle is increased by 10% and its width is increased by 20%, what is the net percentage change in its area?",
      options: ["10% increase", "20% increase", "30% increase", "32% increase"],
      ans: 2
    },
    q16: {
      string: "16. If the price of a product is decreased by 20% and then increased by 20%, what is the net percentage change?",
      options: ["0%", "4%", "16%", "20%"],
      ans: 0
    },
    q17: {
      string: "17. If the value of a car decreases by 25% each year, what is its value after 2 years if its initial value is $8000?",
      options: ["$3600", "$4000", "$4500", "$4800"],
      ans: 1
    },
    q18: {
      string: "18. A salary is increased by 20% and then decreased by 30%. What is the net percentage change in the salary?",
      options: ["10% decrease", "10% increase", "6% decrease", "6% increase"],
      ans: 2
    },
    q19: {
      string: "19. If the price of a product is increased by 10% and then decreased by 20%, what is the net percentage change?",
      options: ["8% decrease", "8% increase", "10% decrease", "10% increase"],
      ans: 0
    },
    q20: {
      string: "20. If the selling price of a product is 125% of its cost price, what is the percentage profit?",
      options: ["25%", "30%", "35%", "40%"],
      ans: 0
    },
    q21: {
      string: "21. If the price of a product is increased by 20% and then decreased by 10%, what is the net percentage change?",
      options: ["8% increase", "8% decrease", "10% increase", "10% decrease"],
      ans: 0
    },
    q22: {
      string: "22. If the population of a town increases by 10% each year, what is the total percentage increase in the population after 3 years?",
      options: ["20%", "30%", "33.1%", "33.3%"],
      ans: 2
    },
    q23: {
      string: "23. A product's price increases by 10% and then decreases by 20%. What is the net percentage change in the price?",
      options: ["8% decrease", "8% increase", "10% decrease", "10% increase"],
      ans: 0
    },
    q24: {
      string: "24. If the length of a rectangle is increased by 25% and its width is decreased by 20%, what is the net percentage change in its area?",
      options: ["5% increase", "5% decrease", "10% increase", "10% decrease"],
      ans: 0
    },
    q25: {
      string: "25. If the selling price of a product is 80% of its cost price, what is the percentage loss?",
      options: ["20%", "30%", "40%", "50%"],
      ans: 0
    }
  };

  const [ques, setques] = useState(que.q1.string);
  const [opts, setoptions] = useState(que.q1.options);
  const [userAns, setUserAns] = useState(null);
  const [userAnswers, setUserAnswers] = useState(Array(25).fill(null));
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [timeLeft, setTimeLeft] = useState(900);
  let timer;
  useEffect(() => {
    timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          submitTest();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const renderNext = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion + 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const renderPrevious = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion - 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const handleAnswer = (answerIndex) => {
    setUserAns(answerIndex);
  };

  const submitTest = () => {
    setTimeLeft(0);

    setUserAnswers((prevUserAnswers) => {
      const newAnswers = [...prevUserAnswers];
      if (userAns !== null) {
        newAnswers[currentQuestion - 1] = userAns;
      }

      let newScore = 0;
      for (let i = 0; i < 25; i++) {
        if (correctAnswers[i] === newAnswers[i]) {
          newScore++;
        }
      }
      setScore(newScore);

      return newAnswers;
    });
  };

  return (
    <div className={props.mode}>
      <div className="heading">
        <h1>APTITUDE <span>PERCENTAGE</span> Test</h1>
      </div>
      <div className="codingInformation">
        <div className="time">
          <h1>Time Left: {formatTime(timeLeft)}</h1> 
        </div>
        <div className="score">
          <span>Your Score: {score}</span>
        </div>
        <div className="tracker">
          <span>Track Your Question</span>
        </div>
      </div>
      <div className="mobileTracker">
        <span>Track Your Question</span>
      </div>
      <div className="mainCodingContainer">
        <div className="questionContainer">
          <p>{ques}</p>
          <div className="options">
            {opts.map((option, index) => (
              <div key={index} className={`opt${index + 1}`}>
                <input
                  type="radio"
                  name={`que${currentQuestion}`}
                  onChange={() => handleAnswer(index)}
                  checked={userAns === index}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
          <div className="btns">
            <button className="btn" onClick={renderPrevious}>Previous</button>
            <button className="btn" onClick={renderNext}>Next</button>
            <button className="btn" id="submitTest" onClick={submitTest}>Submit Test</button>
          </div>
          <div className="mobsub">
          <button className="btn" id="mobileSubmitTest" onClick={submitTest}>Submit Test</button>
          </div>
        </div>
        <div className="questionTrackerContainer">
          <div className="qtboxInformation">
            <div></div>
            <strong>Current</strong>
            <div></div>
            <strong id="solved">Solved</strong>
            <div></div>
            <strong id="unsolved">Unsolved</strong>
          </div>
          <div className="questionTracker">
            {[...Array(25)].map((_, i) => (
              <div
                key={i}
                className={`question ${currentQuestion === i + 1 ? 'current-question' : ''} ${userAnswers[i] !== null ? 'solved' : 'unsolved'}`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
